import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';


import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {QARService} from '../services/qar.service';
import {UITableComponent} from '../framework/ui/table';


import * as moment from 'moment';
import {UIDirectiveDownload} from '../framework/ui/download';


@Component({
	selector: 'app-page-sar',
	templateUrl: './system-access-report.html',
	providers: [QARService]
})
export class SystemAccessReportPageComponent implements OnInit {

	constructor(public api: QARService) {
	}


	@ViewChild('tableComponent', {static: false}) tableComponent: UITableComponent;

	public report = {
		loading: false,
		chunker: (new Chunker([])),
		chunkedData: []
	};
	public reports = {
		loading: false,
		selected: null,
		selectedId: null,
		chunker: (new Chunker([])),
		chunkedData: []
	};

	public report_idFunctionApprover(w) {
		return w['ApproverFirstName'] + ' ' + w['ApproverLastName'];
	}

	/*
	the Title of the System Access Report and the content
	of the System Access Report panel
	list plus all available data for the row,
	including data items that are not present in the system access report panel.
	Should include Override details such as,
	original approval state and rejection reason if relevant,
	new approval state after override,
	 name of overriding user, datetime stamp of override,
	 Countersigner's comments for the approval dataset containing overridden approvals
	 */
	ngOnInit() {
		this.reports.loading = true;
		this.api.retrieveQARReports().then(r => {
			this.reports.loading = false;
			this.reports.chunker = new Chunker(r);
			if (r[0]) {
				this.onReportRowClick(r[0]);
			}
		});
	}

	onReportRowClick(report) {
		this.reports.selected = report;
		this.reports.selectedId = report.Id;
		this.report.loading = true;
		this.api.retrieveQARReportsRows(report.Id).then(r => {
			this.report.loading = false;
			this.report.chunker = new Chunker(r);
		});
	}


	@ViewChild(UIDirectiveDownload, {static: false}) downloader;

	report_openInExcel() {
		this.api.prepareDownloadSystemAccessReportExcelURL(this.reports.selectedId).then((r) => {
			this.downloader.download(this.api.downloadSystemAccessReportExcelURL(this.reports.selectedId, r['code']), null);
		});
	}
}


const Base64 = {

	// private property
	_keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

	// public method for encoding
	encode: function(input) {
		var output = '';
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
		var i = 0;

		input = Base64._utf8_encode(input);

		while (i < input.length) {

			chr1 = input.charCodeAt(i++);
			chr2 = input.charCodeAt(i++);
			chr3 = input.charCodeAt(i++);

			enc1 = chr1 >> 2;
			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
			enc4 = chr3 & 63;

			if (isNaN(chr2)) {
				enc3 = enc4 = 64;
			} else if (isNaN(chr3)) {
				enc4 = 64;
			}

			output = output +
				this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
				this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
		}
		return output;
	},

	// public method for decoding
	decode: function(input) {
		var output = '';
		var chr1, chr2, chr3;
		var enc1, enc2, enc3, enc4;
		var i = 0;

		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

		while (i < input.length) {

			enc1 = this._keyStr.indexOf(input.charAt(i++));
			enc2 = this._keyStr.indexOf(input.charAt(i++));
			enc3 = this._keyStr.indexOf(input.charAt(i++));
			enc4 = this._keyStr.indexOf(input.charAt(i++));

			chr1 = (enc1 << 2) | (enc2 >> 4);
			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
			chr3 = ((enc3 & 3) << 6) | enc4;

			output = output + String.fromCharCode(chr1);

			if (enc3 != 64) {
				output = output + String.fromCharCode(chr2);
			}
			if (enc4 != 64) {
				output = output + String.fromCharCode(chr3);
			}
		}

		output = Base64._utf8_decode(output);

		return output;
	},

	// private method for UTF-8 encoding
	_utf8_encode: function(string) {
		string = string.replace(/\r\n/g, '\n');
		var utftext = '';

		for (var n = 0; n < string.length; n++) {

			var c = string.charCodeAt(n);

			if (c < 128) {
				utftext += String.fromCharCode(c);
			} else if ((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			} else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}
		}
		return utftext;
	},

	// private method for UTF-8 decoding
	_utf8_decode: function(utftext) {
		var string = '';
		var i = 0;
		let c = 0;
		let c1 = 0;
		let c2 = 0;
		let c3 = 0;

		while (i < utftext.length) {

			c = utftext.charCodeAt(i);

			if (c < 128) {
				string += String.fromCharCode(c);
				i++;
			} else if ((c > 191) && (c < 224)) {
				c2 = utftext.charCodeAt(i + 1);
				string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
				i += 2;
			} else {
				c2 = utftext.charCodeAt(i + 1);
				c3 = utftext.charCodeAt(i + 2);
				string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
				i += 3;
			}
		}
		return string;
	}
};
